/* eslint-disable no-restricted-imports */
import { PendingSurveysSetupState } from '@hotjar/webapp/features/Activation/EmptyStates';
import { useCreateSurvey } from '../../../hooks/useCreateSurvey';

export const SurveyEmptyState = (): JSX.Element => {
  const onCreateSurvey = useCreateSurvey();

  return <PendingSurveysSetupState onButtonClick={onCreateSurvey} />;
};
